module.exports = require("usehooks-ts");